import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { palette, StatusBadge, TextTiny } from '@awarego-ui/components';
import SubHeaderText from '../../../../components/header/SubHeaderText';
import pluralize from 'pluralize';
import moment from 'moment/moment';

function ScormSubHeading({ editingAutomation }) {
    if (!editingAutomation) return null;
    const created = editingAutomation._rawData?.created;
    return (
        <Fragment>
            <StatusBadge color={palette.graphite.heavyMetal} text="SCORM" />
            <SubHeaderText
                text={
                    editingAutomation._rawData.totalUsers +
                    ' ' +
                    pluralize(
                        'employee',
                        editingAutomation._rawData.totalUsers
                    ) +
                    ' enrolled'
                }
            />
            {created && (
                <SubHeaderText
                    text={
                        <TextTiny lighter>
                            {'Created on ' + moment(created).format('ll')}
                        </TextTiny>
                    }
                    separator
                />
            )}
        </Fragment>
    );
}

export default observer(ScormSubHeading);
